import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { PaymentProcessorModel } from 'src/app/admin-panel/models/business/payment-processor.model';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { AddOrEditPaymentProcessorsComponent } from './add-or-edit-payment-processors/add-or-edit-payment-processors.component';
import { DeletePaymentProcessorsComponent } from './delete-payment-processors/delete-payment-processors.component';
import { DetailsPaymentProcessorsComponent } from './details-payment-processors/details-payment-processors.component';
import { SuspendPaymentProcessorsComponent } from './suspend-payment-processors/suspend-payment-processors.component';

@Component({
  selector: 'app-payment-processors',
  templateUrl: './payment-processors.component.html',
  styleUrls: ['./payment-processors.component.scss']
})
export class PaymentProcessorsComponent implements OnInit {

  //#region Fields
  public imagePath: string = './assets/images/icons/venue-logo-placeholder.png'
  public paymentProcessorList: Array<PaymentProcessorModel>
  public paymentProcessor1: PaymentProcessorModel;
  public paymentProcessor2: PaymentProcessorModel;
  public paymentProcessor3: PaymentProcessorModel;
  public paymentProcessor4: PaymentProcessorModel;
  public src_drop_opt: Array<DropdownHelperModel>;
  public src_drop_opt_1: DropdownHelperModel;
  public src_drop_opt_2: DropdownHelperModel;
  public selected_drop_opt: DropdownHelperModel;

 


  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService
  ) {
    this.src_drop_opt = new Array<DropdownHelperModel>();
    this.src_drop_opt_1 = new DropdownHelperModel()
    this.src_drop_opt_1.id = '1';
    this.src_drop_opt_1.name = 'A_Z';
    this.src_drop_opt_2 = new DropdownHelperModel()
    this.src_drop_opt_2.id = '2';
    this.src_drop_opt_2.name = 'Z_A';
    this.src_drop_opt.push(this.src_drop_opt_1);
    this.src_drop_opt.push(this.src_drop_opt_2);


     this.paymentProcessorList =new  Array<PaymentProcessorModel>();
     this.paymentProcessor1 =new PaymentProcessorModel();
     this.paymentProcessor1.ImagePath=this.imagePath
     this.paymentProcessor1.Name="Processor Name";
     this.paymentProcessor1.WebSite="www.processor.com";
     this.paymentProcessor1.Members="465";
     this.paymentProcessor1.Payments="22465";
     this.paymentProcessor1.Countries="45";
     this.paymentProcessor1.Currencies="25";
     this.paymentProcessor1.FundsProcessed="$123,465.00";
     this.paymentProcessor2 =new PaymentProcessorModel();
     this.paymentProcessor2.ImagePath=this.imagePath
     this.paymentProcessor2.Name="Processor Name";
     this.paymentProcessor2.WebSite="www.processor.com";
     this.paymentProcessor2.Members="465";
     this.paymentProcessor2.Payments="22465";
     this.paymentProcessor2.Countries="45";
     this.paymentProcessor2.Currencies="25";
     this.paymentProcessor2.FundsProcessed="$123,465.00";
     this.paymentProcessor3 =new PaymentProcessorModel();
     this.paymentProcessor3.ImagePath=this.imagePath
     this.paymentProcessor3.Name="Processor Name";
     this.paymentProcessor3.WebSite="www.processor.com";
     this.paymentProcessor3.Members="465";
     this.paymentProcessor3.Payments="22465";
     this.paymentProcessor3.Countries="45";
     this.paymentProcessor3.Currencies="25";
     this.paymentProcessor3.FundsProcessed="$123,465.00";

     this.paymentProcessor4 =new PaymentProcessorModel();
     this.paymentProcessor4.ImagePath=this.imagePath
     this.paymentProcessor4.Name="Processor Name";
     this.paymentProcessor4.WebSite="www.processor.com";
     this.paymentProcessor4.Members="465";
     this.paymentProcessor4.Payments="22465";
     this.paymentProcessor4.Countries="45";
     this.paymentProcessor4.Currencies="25";
     this.paymentProcessor4.FundsProcessed="$123,465.00";
     
     this.paymentProcessorList.push(this.paymentProcessor1)
     this.paymentProcessorList.push(this.paymentProcessor2)
     this.paymentProcessorList.push(this.paymentProcessor3)
     this.paymentProcessorList.push(this.paymentProcessor4)
  }

  ngOnInit(): void {

  }
  //#endregion
  //#region Public Methods
  addNewPaymentProcessors() {
    const ref = this.dialogService.open(AddOrEditPaymentProcessorsComponent, {
      header: 'Add New Payment Processor',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  loadMorePaymentProcessors() {

  }
  detailsProcessorList(id:string){
    const ref = this.dialogService.open(DetailsPaymentProcessorsComponent, {
      data: {
        id: id
      },
      header: 'Details Payment Processor',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  suspendProcessorList(id:string){
    const ref = this.dialogService.open(SuspendPaymentProcessorsComponent, {
      data: {
        id: id
      },
      header: 'Suspend Payment Processor',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  deleteProcessorList(id:string){
    const ref = this.dialogService.open(DeletePaymentProcessorsComponent, {
      data: {
        id: id
      },
      header: 'Delete Payment Processor',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  //#endregion
  //#Private Methods
  //#endregion
}
